module.exports = __webpack_public_path__ + "static/media/Neck_1.ee061999.jpg";